import { actorDisplayName, actorInitials } from './pulseActorInitials.js'

export default function PulseActor({ name }: { name?: string | null }) {
  const full = actorDisplayName(name)
  const initials = actorInitials(name)
  return (
    <span
      className="pulse-actor"
      title={full}
      aria-label={full}
      data-testid="pulse-actor"
      data-initials={initials}
    >
      {initials}
    </span>
  )
}
